import { Children } from "react";
const deepMapChildren = (children, callback) => {
  Children.map(children, child => {
    var _child$props;
    return child !== null && child !== void 0 && (_child$props = child.props) !== null && _child$props !== void 0 && _child$props.children ? [callback(child), deepMapChildren(child.props.children, callback)] : callback(child);
  });
};
export default deepMapChildren;